import { useEffect } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { setSentryUser } from '@nearst/sentry-config';
import * as Sentry from '@sentry/react';

import { useShop } from '@/hooks/useShop';

const useSentryIdentity = () => {
	const { actor, isSignedIn, userId, orgSlug, orgId } = useAuth();
	const { shop } = useShop();

	useEffect(() => {
		if (actor || !isSignedIn || !userId) {
			setSentryUser(Sentry, { userId: null });
			return;
		}
		setSentryUser(Sentry, { userId, organisation: orgSlug, clerkOrganisationId: orgId, shopId: shop?.id });
	}, [actor, isSignedIn, userId, orgSlug, orgId, shop?.id]);
};

const useMouseflowIdentity = () => {
	const { actor, isSignedIn, userId, orgSlug } = useAuth();
	const { shop } = useShop();
	const { user } = useUser();

	useEffect(() => {
		if (typeof window === 'undefined' || !window._mfq) return;
		if (actor || !isSignedIn || !userId) return;

		const email = user?.primaryEmailAddress?.emailAddress;
		window._mfq.push(['identify', { id: userId, email }]);
		if (orgSlug) window._mfq.push(['setVariable', 'organisation', orgSlug]);
		if (shop?.id) window._mfq.push(['setVariable', 'shopId', shop.id]);
	}, [actor, isSignedIn, userId, orgSlug, shop?.id, user?.primaryEmailAddress?.emailAddress]);
};

export function AnalyticsWrapper({ children }) {
	useSentryIdentity();
	useMouseflowIdentity();
	return children;
}
